import { Button } from "./Button";
import { Globe, Mail, Phone } from "lucide-react";
import { ContactButtonsProps } from "../types";

const ContactButtons: React.FC<ContactButtonsProps> = ({ tenantDetail }) => {
  const gradientStyle =
    "bg-gradient-to-r from-[#16222A] via-[#3A6073] to-[#16222A] text-white shadow-[inset_0_2px_4px_rgba(0,0,0,0.2),0_4px_8px_rgba(0,0,0,0.2)] transition duration-300 hover:shadow-[inset_0_1px_2px_rgba(0,0,0,0.2),0_2px_4px_rgba(0,0,0,0.2)] hover:translate-y-0.5 active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.2),0_1px_2px_rgba(0,0,0,0.2)] active:translate-y-1";

  if (
    !tenantDetail.contact_phone &&
    !tenantDetail.support_email &&
    !tenantDetail.website
  ) {
    return null;
  }

  return (
    <div className="relative px-1 py-1.5 border-t border-zinc-100">
      <div className="flex overflow-x-auto gap-2">
        {tenantDetail.website && (
          <a
            href={
              tenantDetail.website.startsWith("http")
                ? tenantDetail.website
                : `https://${tenantDetail.website}`
            }
            target="_blank"
            rel="noreferrer"
          >
            <Button size="sm" className={`${gradientStyle}`}>
              <Globe className="h-4 w-4 mr-2" />
              <span>Website</span>
            </Button>
          </a>
        )}
        {tenantDetail.support_email && (
          <a
            href={`mailto:${tenantDetail.support_email}`}
            target="_blank"
            rel="noreferrer"
          >
            <Button size="sm" className={`${gradientStyle}`}>
              <Mail className="h-4 w-4 mr-2" />
              <span>Email</span>
            </Button>
          </a>
        )}
        {tenantDetail.contact_phone && (
          <a
            href={`tel:${tenantDetail.contact_phone}`}
            target="_blank"
            rel="noreferrer"
          >
            <Button size="sm" className={`${gradientStyle}`}>
              <Phone className="h-4 w-4 mr-2" />
              <span>Phone</span>
            </Button>
          </a>
        )}
      </div>
    </div>
  );
};

export default ContactButtons;
